import { apiClient } from '@/lib/apiClient';
import type { LocalEstoque, LocalEstoqueCombo, SalvarLocalEstoqueRequest } from '../types';

const BASE = '/api/cadastros/locais-estoque';

export const localEstoqueService = {
  getCombo: () =>
    apiClient.get<LocalEstoqueCombo[]>('/api/locais-estoque').then(r => r.data),

  listar: (busca?: string) =>
    apiClient.get<{ itens: LocalEstoque[]; total: number }>(BASE, {
      params: { busca, tamanhoPagina: 200 },
    }).then(r => r.data),

  getById: (id: number) =>
    apiClient.get<LocalEstoque>(`${BASE}/${id}`).then(r => r.data),

  criar: (req: SalvarLocalEstoqueRequest) =>
    apiClient.post<LocalEstoque>(BASE, req).then(r => r.data),

  atualizar: (id: number, req: SalvarLocalEstoqueRequest) =>
    apiClient.put(`${BASE}/${id}`, req).then(r => r.data),

  excluir: (id: number) =>
    apiClient.delete(`${BASE}/${id}`).then(r => r.data),
};
